import type { ReactNode } from 'react';

export function NotEmbeddedError(): ReactNode {
  return (
    <div className="standalone-notice">
      <div className="standalone-content">
        <h1>Transit Data Source</h1>
        <p className="standalone-embed-hint">
          This applet must be embedded within VenueOS to function. Please access it through the
          VenueOS dashboard.
        </p>
      </div>
    </div>
  );
}
